import { ActionTypes } from "./action-types";
import { initialState } from './state';

const mutations = {
  [ActionTypes.GET_STOCKS_DATA](state, data) {
    state.stockDetails = data;
  },
  [ActionTypes.RESET_STATE](state) {
    Object.assign(state, initialState);
},
};

export default mutations;
